import { render, staticRenderFns } from "./LivePlaying.vue?vue&type=template&id=0ec0811e&scoped=true&"
import script from "./LivePlaying.vue?vue&type=script&lang=js&"
export * from "./LivePlaying.vue?vue&type=script&lang=js&"
import style0 from "./LivePlaying.vue?vue&type=style&index=0&id=0ec0811e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0811e",
  null
  
)

export default component.exports